<script lang="ts">
  interface Props {
    onFile: (file: File) => void
    label?: string
  }

  const { onFile, label = 'Drop a city file, or click to choose' }: Props = $props()

  let dragOver = $state(false)
  let inputEl: HTMLInputElement | undefined = $state()

  function pick() {
    inputEl?.click()
  }

  function onChange(ev: Event) {
    const file = (ev.target as HTMLInputElement).files?.[0]
    if (file) onFile(file)
    if (inputEl) inputEl.value = '' // allow re-selecting the same file
  }

  function onDragOver(ev: DragEvent) {
    ev.preventDefault()
    dragOver = true
  }
  function onDragLeave() {
    dragOver = false
  }
  function onDrop(ev: DragEvent) {
    ev.preventDefault()
    dragOver = false
    const file = ev.dataTransfer?.files?.[0]
    if (file) onFile(file)
  }
</script>

<button
  type="button"
  class="block w-full rounded-lg border-2 border-dashed p-6 text-center transition-colors focus:outline-none focus:ring-2 focus:ring-accent-bright"
  class:border-border-rule={!dragOver}
  class:border-accent={dragOver}
  class:bg-surface-3={!dragOver}
  class:bg-accent-deep={dragOver}
  ondragover={onDragOver}
  ondragleave={onDragLeave}
  ondrop={onDrop}
  onclick={pick}
>
  <span class="text-sm text-chrome-text-2">{label}</span>
  <input
    bind:this={inputEl}
    type="file"
    accept=".txt,.json,application/json,text/plain"
    class="hidden"
    onchange={onChange}
  />
</button>
